import type { StartPayConfig } from "../types/config";
import type { StartPaymentInput } from "../types/payment";
import { StartPayError } from "./errors";

const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const phoneRegex = /^[+()0-9\-\s]{7,20}$/;

export const validateConfig = (config: StartPayConfig) => {
  const unsafe = config as StartPayConfig & { secretKey?: string };

  if (unsafe.secretKey) {
    throw new StartPayError(
      "Do not pass secretKey to StartButton-Payment-Gateway frontend SDK. Keep gateway secrets on your backend only.",
      "SECRET_KEY_NOT_ALLOWED"
    );
  }
  if (!config.publicKey?.trim()) throw new StartPayError("publicKey is required", "INVALID_CONFIG");
  if (!config.apiBaseUrl?.trim()) throw new StartPayError("apiBaseUrl is required", "INVALID_CONFIG");
  if (config.environment !== "sandbox" && config.environment !== "production") {
    throw new StartPayError("environment must be either sandbox or production", "INVALID_CONFIG");
  }
};

export const validatePaymentInput = (input: StartPaymentInput) => {
  if (!Number.isFinite(input.amount) || input.amount <= 0) {
    throw new StartPayError("amount must be greater than 0", "INVALID_PAYMENT_INPUT");
  }
  if (!input.currency?.trim()) throw new StartPayError("currency is required", "INVALID_PAYMENT_INPUT");
  if (!input.orderId?.trim()) throw new StartPayError("orderId is required", "INVALID_PAYMENT_INPUT");
  if (input.customer?.email && !emailRegex.test(input.customer.email)) {
    throw new StartPayError("customer.email must be a valid email address", "INVALID_PAYMENT_INPUT");
  }
  if (input.customer?.phone && !phoneRegex.test(input.customer.phone)) {
    throw new StartPayError("customer.phone must be a valid phone number", "INVALID_PAYMENT_INPUT");
  }
};
